import PropTypes from "prop-types";
import { Form } from "@circle-react-uikit/Form";
import { mapSettingsToDefaultFromValues } from "./helpers";

export const EditHomeForm = ({
  onSubmit,
  onCancel,
  settings,
  children,
  ...rest
}) => {
  const formDefaultValues = mapSettingsToDefaultFromValues(settings);

  return (
    <Form
      id="edit-home-form"
      onSubmit={onSubmit}
      onCancel={onCancel}
      defaultValues={formDefaultValues}
      {...rest}
    >
      {children}
    </Form>
  );
};

EditHomeForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  settings: PropTypes.object,
  children: PropTypes.node,
};
